/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RoleFieldsFragmentDoc, RecordMetaFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVitallPatientRecordQueryVariables = Types.Exact<{
  input: Types.GetVitallPatientRecordInput;
  is_curator?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  is_practitioner?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetVitallPatientRecordQuery = { __typename?: 'Query', getVitallPatientRecord?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, user_id?: string | null, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, allow_emergency_access: boolean, date_of_birth?: string | null, validic_id?: string | null, curator_user_id?: string | null, practitioner_user_id?: string | null, status_id?: string | null, status?: { __typename?: 'StatusModel', internal: boolean, public_name: string, status_id: string, private_name: string, sequence?: number | null } | null, user?: { __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, created_user_id?: string | null, email?: string | null, first_name: string, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, updated_at: string, user_id: string, vitall_user_id?: number | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }> } | null, curator?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null, practitioner?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null } | null };

export type GetVitallPatientRecordMetaQueryVariables = Types.Exact<{
  input: Types.GetVitallPatientRecordInput;
}>;


export type GetVitallPatientRecordMetaQuery = { __typename?: 'Query', getVitallPatientRecord?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, curator_user_id?: string | null, practitioner_user_id?: string | null, status_id?: string | null, recordMeta?: { __typename?: 'RecordMeta', New: number, NeedsReview: number, Draft: number, Published: number } | null, status?: { __typename?: 'StatusModel', private_name: string, public_name: string, status_id: string, color?: string | null, sequence?: number | null } | null } | null };

export type AssignUserToPatientMutationVariables = Types.Exact<{
  input: Types.UpdatePatientAssignedUserInput;
}>;


export type AssignUserToPatientMutation = { __typename?: 'Mutation', assignUserToPatient: { __typename?: 'UpdateVitallPatientResponse', message: string, data?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, curator_user_id?: string | null, practitioner_user_id?: string | null, curator?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null, practitioner?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null } | null } };

export type UpdateEmergencyAccessMutationVariables = Types.Exact<{
  input: Types.UpdatePatientEmergencyAccessInput;
}>;


export type UpdateEmergencyAccessMutation = { __typename?: 'Mutation', updateEmergencyAccess: { __typename?: 'UpdateVitallPatientResponse', message: string, data?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, allow_emergency_access: boolean } | null } };

export type UpdatePatientProfileStatusMutationVariables = Types.Exact<{
  input: Types.UpdatePatientProfileStatusInput;
}>;


export type UpdatePatientProfileStatusMutation = { __typename?: 'Mutation', updateProfileStatus: { __typename?: 'UpdateVitallPatientResponse', message: string, data?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, status_id?: string | null, status?: { __typename?: 'StatusModel', internal: boolean, public_name: string, status_id: string, private_name: string } | null } | null } };


export const GetVitallPatientRecordDocument = gql`
    query getVitallPatientRecord($input: GetVitallPatientRecordInput!, $is_curator: Boolean = false, $is_practitioner: Boolean = false) {
  getVitallPatientRecord(input: $input) {
    vitall_patient_id
    patient_id
    user_id
    created_at
    updated_at
    is_deleted
    allow_emergency_access
    date_of_birth
    validic_id
    curator_user_id
    practitioner_user_id
    status_id
    status {
      internal
      public_name
      status_id
      private_name
      sequence
    }
    user {
      account_id
      cognito_id
      created_at
      created_user_id
      email
      first_name
      last_login
      last_name
      profile_picture
      status
      title
      updated_at
      user_id
      vitall_user_id
      roles {
        ...RoleFields
      }
    }
    curator @include(if: $is_curator) {
      user_id
      first_name
      last_name
    }
    practitioner @include(if: $is_practitioner) {
      user_id
      first_name
      last_name
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export function useGetVitallPatientRecordQuery(baseOptions: Apollo.QueryHookOptions<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables> & ({ variables: GetVitallPatientRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>(GetVitallPatientRecordDocument, options);
      }
export function useGetVitallPatientRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>(GetVitallPatientRecordDocument, options);
        }
// @ts-ignore
export function useGetVitallPatientRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>;
export function useGetVitallPatientRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetVitallPatientRecordQuery | undefined, GetVitallPatientRecordQueryVariables>;
export function useGetVitallPatientRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>(GetVitallPatientRecordDocument, options);
        }
export type GetVitallPatientRecordQueryHookResult = ReturnType<typeof useGetVitallPatientRecordQuery>;
export type GetVitallPatientRecordLazyQueryHookResult = ReturnType<typeof useGetVitallPatientRecordLazyQuery>;
export type GetVitallPatientRecordSuspenseQueryHookResult = ReturnType<typeof useGetVitallPatientRecordSuspenseQuery>;
export type GetVitallPatientRecordQueryResult = Apollo.QueryResult<GetVitallPatientRecordQuery, GetVitallPatientRecordQueryVariables>;
export const GetVitallPatientRecordMetaDocument = gql`
    query getVitallPatientRecordMeta($input: GetVitallPatientRecordInput!) {
  getVitallPatientRecord(input: $input) {
    vitall_patient_id
    patient_id
    curator_user_id
    practitioner_user_id
    recordMeta {
      ...RecordMetaFields
    }
    status_id
    status {
      private_name
      public_name
      status_id
      color
      sequence
    }
  }
}
    ${RecordMetaFieldsFragmentDoc}`;
export function useGetVitallPatientRecordMetaQuery(baseOptions: Apollo.QueryHookOptions<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables> & ({ variables: GetVitallPatientRecordMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>(GetVitallPatientRecordMetaDocument, options);
      }
export function useGetVitallPatientRecordMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>(GetVitallPatientRecordMetaDocument, options);
        }
// @ts-ignore
export function useGetVitallPatientRecordMetaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>): Apollo.UseSuspenseQueryResult<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>;
export function useGetVitallPatientRecordMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>): Apollo.UseSuspenseQueryResult<GetVitallPatientRecordMetaQuery | undefined, GetVitallPatientRecordMetaQueryVariables>;
export function useGetVitallPatientRecordMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>(GetVitallPatientRecordMetaDocument, options);
        }
export type GetVitallPatientRecordMetaQueryHookResult = ReturnType<typeof useGetVitallPatientRecordMetaQuery>;
export type GetVitallPatientRecordMetaLazyQueryHookResult = ReturnType<typeof useGetVitallPatientRecordMetaLazyQuery>;
export type GetVitallPatientRecordMetaSuspenseQueryHookResult = ReturnType<typeof useGetVitallPatientRecordMetaSuspenseQuery>;
export type GetVitallPatientRecordMetaQueryResult = Apollo.QueryResult<GetVitallPatientRecordMetaQuery, GetVitallPatientRecordMetaQueryVariables>;
export const AssignUserToPatientDocument = gql`
    mutation assignUserToPatient($input: UpdatePatientAssignedUserInput!) {
  assignUserToPatient(input: $input) {
    message
    data {
      vitall_patient_id
      patient_id
      curator_user_id
      practitioner_user_id
      curator {
        user_id
        first_name
        last_name
      }
      practitioner {
        user_id
        first_name
        last_name
      }
    }
  }
}
    `;
export type AssignUserToPatientMutationFn = Apollo.MutationFunction<AssignUserToPatientMutation, AssignUserToPatientMutationVariables>;
export function useAssignUserToPatientMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserToPatientMutation, AssignUserToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserToPatientMutation, AssignUserToPatientMutationVariables>(AssignUserToPatientDocument, options);
      }
export type AssignUserToPatientMutationHookResult = ReturnType<typeof useAssignUserToPatientMutation>;
export type AssignUserToPatientMutationResult = Apollo.MutationResult<AssignUserToPatientMutation>;
export type AssignUserToPatientMutationOptions = Apollo.BaseMutationOptions<AssignUserToPatientMutation, AssignUserToPatientMutationVariables>;
export const UpdateEmergencyAccessDocument = gql`
    mutation updateEmergencyAccess($input: UpdatePatientEmergencyAccessInput!) {
  updateEmergencyAccess(input: $input) {
    message
    data {
      vitall_patient_id
      allow_emergency_access
    }
  }
}
    `;
export type UpdateEmergencyAccessMutationFn = Apollo.MutationFunction<UpdateEmergencyAccessMutation, UpdateEmergencyAccessMutationVariables>;
export function useUpdateEmergencyAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmergencyAccessMutation, UpdateEmergencyAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmergencyAccessMutation, UpdateEmergencyAccessMutationVariables>(UpdateEmergencyAccessDocument, options);
      }
export type UpdateEmergencyAccessMutationHookResult = ReturnType<typeof useUpdateEmergencyAccessMutation>;
export type UpdateEmergencyAccessMutationResult = Apollo.MutationResult<UpdateEmergencyAccessMutation>;
export type UpdateEmergencyAccessMutationOptions = Apollo.BaseMutationOptions<UpdateEmergencyAccessMutation, UpdateEmergencyAccessMutationVariables>;
export const UpdatePatientProfileStatusDocument = gql`
    mutation updatePatientProfileStatus($input: UpdatePatientProfileStatusInput!) {
  updateProfileStatus(input: $input) {
    message
    data {
      vitall_patient_id
      status_id
      status {
        internal
        public_name
        status_id
        private_name
      }
    }
  }
}
    `;
export type UpdatePatientProfileStatusMutationFn = Apollo.MutationFunction<UpdatePatientProfileStatusMutation, UpdatePatientProfileStatusMutationVariables>;
export function useUpdatePatientProfileStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientProfileStatusMutation, UpdatePatientProfileStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientProfileStatusMutation, UpdatePatientProfileStatusMutationVariables>(UpdatePatientProfileStatusDocument, options);
      }
export type UpdatePatientProfileStatusMutationHookResult = ReturnType<typeof useUpdatePatientProfileStatusMutation>;
export type UpdatePatientProfileStatusMutationResult = Apollo.MutationResult<UpdatePatientProfileStatusMutation>;
export type UpdatePatientProfileStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePatientProfileStatusMutation, UpdatePatientProfileStatusMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetVitallPatientRecord = withQueryResponseHandler(useGetVitallPatientRecordQuery);
export const useGetVitallPatientRecordMeta = withQueryResponseHandler(useGetVitallPatientRecordMetaQuery);
export const useAssignUserToPatient = withMutationResponseHandler(useAssignUserToPatientMutation, "assignUserToPatient");
export const useUpdateEmergencyAccess = withMutationResponseHandler(useUpdateEmergencyAccessMutation, "updateEmergencyAccess");
export const useUpdatePatientProfileStatus = withMutationResponseHandler(useUpdatePatientProfileStatusMutation, "updatePatientProfileStatus");